<template>
  <div>

    <!-- Show coach view for rubric. -->
    <div
      class="rubrics-content"
      v-if="evaluation_type == 'reviewer_scored' && showScoring() && mode !== 'learner'"
    >
      <md-list class="list">
        <md-list-item md-expand class="rubrics-content-expand coach">
          <span class="md-list-item-text" @click="rubricToggle">
            {{ rubricTitle }}
          </span>
          <div slot="md-expand">
            <div
              class="criteria-content md-layout"
              v-bind:key="index"
              v-for="(criteria, index) in items"
            >
              <div class="criteria-title md-xsmall-size-100 md-layout-item">
                <div>{{ criteria.title }}</div>
              </div>
              <div
                class="md-layout-item md-xsmall-size-100"
                :key="score"
                v-for="(description, score) in criteria.items"
              >
                <div class="md-layout">
                  <div class="radio-elm md-layout-item md-size-15">
                    <md-radio
                      :disabled="mode == 'learner'"
                      :value="score"
                      v-model="criteria.checked"
                      @change="calculateScore"
                    ></md-radio>
                  </div>
                  <div class="md-layout-item">
                    {{ score }}
                    <div v-html="description.description">
                      {{ description.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="score md-xsmall-size-100 md-layout-item">
              Score: {{ totalScore }}%
              <div class="average-score">Avg. Score: {{ avgScore }}%</div>
            </div>
            <div v-if="mode == 'learner' && element_uuid" class="feedback">
              <feedback :submissionUuid="element_uuid"/>
            </div>
          </div>
        </md-list-item>
      </md-list>
    </div>

    <div
      class="rubrics-content"
      v-if="mode == 'learner'"
    >
      <!-- Show learner view for multi-coaches rubric. -->
      <md-list class="list" v-if="dataReady && showScoring() && coachSubmissions.length > 0">
          <md-list-item md-expand class="rubrics-content-expand" v-for="(submission, key) in coachSubmissions">
          <span class="md-list-item-text" @click="rubricToggle">
            <span class="feedback-title"
                  :class="evaluation_type == 'reviewer_scored' ? 'reviewer-scored' : ''">{{ submission.coach }} Feedback - {{ submission.changed }}</span>
            <span v-if="evaluation_type == 'reviewer_scored'" class="score">{{ submission.score }}%</span>
          </span>
          <div slot="md-expand" v-if="evaluation_type == 'reviewer_scored'">
            <div
              class="criteria-content md-layout md-xsmall-size-100"
              v-bind:key="index"
              v-for="(criteria, index) in submission.items"
            >
              <div class="criteria-title md-layout-item md-xsmall-size-100">
                <div>{{ criteria.title }}</div>
              </div>
              <div
                class="md-layout-item md-xsmall-size-100"
                :key="score"
                v-for="(description, score) in criteria.items"
              >
                <div class="md-layout">
                  <div class="radio-elm md-layout-item md-size-15">
                    <md-radio
                      :disabled="mode == 'learner'"
                      :value="score"
                      v-model="criteria.checked"
                      @change="calculateScore"
                    ></md-radio>
                  </div>
                  <div class="md-layout-item">
                    {{ score }}
                    <div v-html="description.description">
                      {{ description.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="score md-layout-item md-xsmall-size-100">
              Score: {{ submission.score }}%
              <div class="average-score">Avg. Score: {{ avgScore }}%</div>
            </div>
            <div v-if="mode == 'learner' && element_uuid" class="feedback">
              <feedback :submissionUuid="element_uuid" :userUuid="submission.coach_uuid"
                :submission-view-mode="submissionViewMode"/>
            </div>
          </div>
        </md-list-item>
        </md-list>

      <md-list class="list" v-if="feedbacks.length > 0 && dataReady && (evaluation_type != 'reviewer_scored' || isSet())">
        <md-list-item md-expand class="rubrics-content-expand" v-for="(feedback) in feedbacks">
          <span class="md-list-item-text" @click="rubricToggle">
             <span class="feedback-title"
                   :class="evaluation_type == 'reviewer_scored' ? 'reviewer-scored' : ''">
               {{ feedback.coach }} Feedback - {{ feedback.changed }}
             </span>
          </span>
          <div slot="md-expand">
            <div class="feedback">
              <div class="comment-wrapper">
                <div class="title">Feedback:</div>
                <div class="content">
                  <md-card>
                    <md-card-content class="text-left">
                      <div v-html="feedback.comment"></div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>

            </div>
          </div>
        </md-list-item>
      </md-list>
      <!-- Show default rubric. -->
      <md-list class="list"  v-if="dataReady && showScoring() && evaluation_type == 'reviewer_scored' && coachSubmissions.length < 1">
        <md-list-item md-expand class="default rubrics-content-expand">
          <span class="md-list-item-text" @click="rubricToggle">
            {{ rubricTitle }}
          </span>
          <div slot="md-expand">
            <div
              class="criteria-content md-layout md-xsmall-size-100"
              v-bind:key="index"
              v-for="(criteria, index) in items"
            >
              <div class="criteria-title md-layout-item md-xsmall-size-100">
                <div>{{ criteria.title }}</div>
              </div>
              <div
                class="md-layout-item md-xsmall-size-100"
                :key="score"
                v-for="(description, score) in criteria.items"
              >
                <div class="md-layout">
                  <div class="radio-elm md-layout-item md-size-15">
                    <md-radio
                      :disabled="mode == 'learner'"
                      :value="score"
                      v-model="criteria.checked"
                      @change="calculateScore"
                    ></md-radio>
                  </div>
                  <div class="md-layout-item">
                    {{ score }}
                    <div v-html="description.description">
                      {{ description.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="score md-layout-item md-xsmall-size-100">
              Score: {{ score }}%
              <div class="average-score">Avg. Score: {{ avgScore }}%</div>
            </div>
          </div>
        </md-list-item>
      </md-list>
    </div>

  </div>
</template>

<script>
import Feedback from "../components/Feedback.vue";
import Vue from "vue";

export default {
  name: "CoachRubrics",
  props: [
    "element_uuid",
    "mode",
    "feedback",
    "feedbackUuid",
    "is_final",
    "form",
    "submission-view-mode"
  ],
  components: {
    Feedback,
  },
  data() {
    return {
      items: drupalSettings.rubrics,
      evaluation_type: drupalSettings.evaluation_type,
      user: drupalSettings.user,
      dataReady: false,
      coachSubmissionUuid: null,
      coachSubmissions: [],
      isRubricsOpen: true,
      loading: false,
      totalScore: 0,
      avgScore: 0,
      submitted: false,
      feedbacks: []
    };
  },
  mounted() {
    if (!this.isSet()) {
      this.getAverageScore();
    }

    if (this.mode == "learner" && this.evaluation_type == 'reviewer_scored' && !this.isSet()) {
      this.getLearnerRubric();
    } else if ((this.mode == "learner" && this.evaluation_type != 'reviewer_scored') || (this.isSet())) {
      this.getFeedbacks()
    }
    if (this.mode != "learner") {
      this.getCoachSubmission();
    }

  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    async calculateScore() {
      const calculation = await this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/json");
        fetch_headers.append("X-CSRF-Token", token);
        return fetch("/api/v1/calculate-rubrics-score", {
          credentials: "include",
          method: "POST",
          headers: fetch_headers,
          dataType: "json",
          body: JSON.stringify({
            rubric: this.items,
            uuid: this.element_uuid,
          }),
        });
      });
      this.totalScore = await calculation.text();
    },

    showScoring() {
      return (
        ["go", "field_go_form", "activity", "activity_form"].indexOf(
          this.form
        ) !== -1
      );
    },
    getMessageClass() {
      return !this.validate() ? "invalid" : "submitted";
    },

    validate() {
      if (this.evaluation_type != "reviewer_scored") {
        return true;
      } else if (this.evaluation_type == "reviewer_scored" && this.isSet()) {
        return true;
      }
      let checked = [];
      let data = this.items;
      for (var criteria in data) {
        let checkedLabel = data[criteria].checked;
        for (var label in data[criteria].items) {
          if (checkedLabel == label) {
            checked[criteria] = true;
          }
        }
      }
      if (checked.length == data.length) {
        return true;
      }
      return false;
    },

    isSet() {
      return ["field_set_form", "set"].indexOf(this.form) !== -1;
    },

    rubricToggle() {
      this.isRubricsOpen = !this.isRubricsOpen;
    },

    getChecked(data) {
      for (var criteria in data) {
        let checkedLabel = data[criteria].checked;
        for (var label in data[criteria].items) {
          if (checkedLabel == label) {
            data[criteria].items[label].checked = true;
          }
        }
      }
      return data;
    },

    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        return text;
      });
    },

    getCoachSubmission() {
      if (!(drupalSettings.evaluation_type == "reviewer_scored")) {
        return;
      }

      let self = this;
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        fetch(
          "/jsonapi/coach_submission/coach_submission?filter[user.id]=" +
          this.user.uuid +
          "&filter[submission_uuid]=" +
          this.element_uuid,
          {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          }
        )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json.hasOwnProperty("data")) {
            let data = json.data.shift();
            if (data.hasOwnProperty("id")) {
              self.coach_submission = data;
              self.coachSubmissionUuid = data.id;
              self.items = self.getChecked(
                JSON.parse(data.attributes.data.value).rubric
              );
              self.loading = false;
              self.totalScore = data.attributes.score;
              self.submitted = true;
            }
          }
        });
      });
    },

    setCoachSubmission() {
      this.loading = true;
      return this.getToken().then(async (token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let method = "POST";
        if (this.coachSubmissionUuid != null) {
          method = "PATCH";
        }
        let feedback_method = "POST";
        if (this.feedbackUuid) {
          feedback_method = "PATCH";
        }
        await fetch(
          "/jsonapi/catch_comment/catch_comment" +
          (this.feedbackUuid ? "/" + this.feedbackUuid : ""),
          {
            credentials: "include",
            method: feedback_method,
            headers: fetch_headers,
            body: JSON.stringify({
              data: {
                id: this.feedbackUuid,
                type: "catch_comment--catch_comment",
                attributes: {
                  submission_uuid: this.element_uuid,
                  comment: this.feedback,
                  entity_type: window.drupalSettings.entityType || null,
                  entity_id: window.drupalSettings.entityId || null,
                },
              },
            }),
          }
        )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.$emit("update-feedback-uuid", json.data.id);
          if (this.evaluation_type != "reviewer_scored") {
            self.loading = false;
            self.submitted = true;
            this.$emit("messageClassUpdate", "submitted");
          }
        });
        if (this.evaluation_type == "reviewer_scored") {
          await fetch(
            "/jsonapi/coach_submission/coach_submission" +
            (this.coachSubmissionUuid != null
              ? "/" + this.coachSubmissionUuid
              : ""),
            {
              credentials: "include",
              method: method,
              headers: fetch_headers,
              body: JSON.stringify({
                data: {
                  id: this.coachSubmissionUuid,
                  type: "coach_submission--coach_submission",
                  attributes: {
                    submission_uuid: this.element_uuid,
                    data: JSON.stringify({
                      rubric: this.items,
                    }),
                  },
                },
              }),
            }
          )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            this.coach_submission = "";
            this.getCoachSubmission();
          });
        }
      });
    },

    getAverageScore() {
      let self = this;
      if (!this.element_uuid) {
        return drupalSettings.rubrics;
      } else {
        return this.getToken().then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/json");
          fetch_headers.append("X-CSRF-Token", token);
          fetch("/ajax/catch-common/get-learner-rubrics/" + this.element_uuid, {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            self.avgScore = data.score;
          });
        });
      }
    },

    getLearnerRubric() {
      let self = this;
      if (!this.element_uuid) {
        self.dataReady = true;
        return [drupalSettings.rubrics];
      } else {
        this.getToken().then(token => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          fetch("/jsonapi/coach_submission/coach_submission?include=user&filter[submission_uuid]=" + this.element_uuid, {
            credentials: "include",
            method: 'GET',
            headers: fetch_headers,
          })
          .then(response => {
            return response.json();
          })
          .then(json => {
            if (json.hasOwnProperty('data')) {
              let included = {};
              if (json.included) {
                json.included.forEach((data) => {
                  included[data.id] = data;
                });
              }
              json.data.forEach((submission) => {
                self.coachSubmissions.push(
                  {
                    id: submission.id,
                    changed: this.$moment(submission.attributes.changed).format("MM/DD/YYYY"),
                    items: self.getChecked(JSON.parse(submission.attributes.data.value).rubric),
                    score: submission.attributes.score,
                    coach: included[submission.relationships.user.data.id].attributes.display_name,
                    coach_uuid: included[submission.relationships.user.data.id].id
                  }
                );

              });
            }
            self.dataReady = true;
          });
        });

      }
    },

    getFeedbacks() {
      let self = this;
      this.getToken().then(token => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let requestUrl = "/jsonapi/catch_comment/catch_comment?include=user&" +
          "filter[element_uuid][condition][path]=element_uuid" +
          "&filter[element_uuid][condition][operator]=IS NULL" +
          "&filter[submission_uuid]=" + this.element_uuid;
        return fetch(requestUrl,
          {
            credentials: "include",
            method: "GET",
            headers: fetch_headers
          }
        )
        .then(response => {
          return response.json();
        })
        .then(json => {

          if (json.hasOwnProperty('data')) {
            let included = {};
            if (json.included) {
              json.included.forEach((data) => {
                included[data.id] = data;
              });
            }
            let feedbacks = [];
            json.data.forEach((feedback) => {
              self.feedbacks.push(
                {
                  id: feedback.id,
                  changed: this.$moment(feedback.attributes.changed).format("MM/DD/YYYY"),
                  coach: included[feedback.relationships.user.data.id].attributes.display_name,
                  comment: feedback.attributes.comment.value
                }
              );
            });
            this.dataReady = true;
          }
        });
      });
    },
  },

  watch: {
    submitted(newVal) {
      this.$emit("messageClassUpdate", this.getMessageClass());
    },
  },
  computed: {
    rubricTitle() {
      if (this.isRubricsOpen) {
        return "Open Rubric";
      } else {
        return "Close Rubric";
      }
    },
  },
};
</script>
<style lang="scss">
.rubrics {
  .feedback {
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      text-align: left;
    }

    .comment-wrapper {
      .md-card-header {
        display: none;
      }

      .md-card {
        margin: 0;
      }

      .md-card-content {
        white-space: initial;
        padding-bottom: 10px;
        padding-top: 10px;
      }
    }
  }

  & > div > .feedback {
    margin-top: 24px;
    border-radius: 20px;
    background: $blue-dark;
    padding: 10px 24px 24px;

    .md-card-content {
      color: rgb(60, 60, 60);
      background-color: #ffffff;
      border-radius: 10px;
    }
  }
}

.rubrics-content {
  margin-top: 25px;
  color: #ffffff;

  .rubrics-content-expand {
    .md-list-item-content {
      .feedback-title {
        display: block;
        white-space: initial;
        padding-top: 25px;
        padding-bottom: 25px;

        &.reviewer-scored {
          max-width: 50%;
          @media all and (max-width: $breakpoint-medium) {
            max-width: unset;
          }
        }
      }

      .md-icon {
        color: #ffffff;

        svg {
          fill: #ffffff;
        }
      }
    }

  }

  > ul {
    background-color: unset !important;
    list-style: none;
    padding: 0px;

    i {
      svg {
        fill {
          color: #ffffff !important;
        }
      }
    }

    .md-list-item-content:hover {
      background: unset;
    }

    li.default {
      .md-list-item-text {
        align-items: center;
      }
    }

    li {
      border-radius: 20px;
      background: $blue-dark !important;
      margin-bottom: 35px;

      .md-list-item-expand {
        border: none;
      }

      .md-list-expand {
        @media all and (max-width: $breakpoint-medium) {
          > div {
            .criteria-title {
              padding: 30px 0px;
              background: #eeeeee;
            }

            .criteria-content:first-child {
              > div:first-child {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
              }

              > div:last-child {
                border-top-right-radius: unset !important;
                border-top-left-radius: unset !important;
              }
            }

            .average-score {
              display: none;
            }
          }
        }

        > div {
          padding-left: 25px;
          padding-right: 25px;

          .criteria-content:first-child {
            overflow: hidden;

            > div:first-child {
              border-top-left-radius: 20px;
            }

            > div:last-child {
              border-top-right-radius: 20px;
            }
          }
        }

        .score {
          margin-bottom: 25px;
          border-bottom-right-radius: 20px;
          border-bottom-left-radius: 20px;
        }
      }
    }

    li.coach {
      margin-bottom: unset;
      border-radius: unset;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .md-list-item-text {
        align-items: center;
        padding: 15px 0px;
      }
    }

    .md-list-item-text {
      font-size: 18px;
      font-weight: bold;
      text-transform: capitalize;
      //min-height: 70px;
      padding: 0 15px;
      position: relative;
      //text-align: center;
      margin: 0 auto;
      //display: block;
      color: #ffffff;
    }

    .criteria-title {
      display: flex;
      align-items: center;
      font-weight: bold;

      div {
        text-align: center;
        margin: 10px;
        width: 100%;
      }

      //display: flex;
      //align-items: center;
    }

    .md-layout-item {
      word-break: break-word;
      background: #ffffff;
      color: black;
      margin: 2px;
      white-space: normal;
      padding: 10px;

      .md-layout-item {
        padding: 0px;
      }

      p {
        margin: 0px;
      }

      .radio-elm {
        align-items: center;
        display: flex;
      }
    }

    .md-radio-container {
      border-color: $blue-active !important;
    }

    .md-radio.md-theme-default.md-checked
    .md-radio-container.md-radio-container:after {
      background-color: $blue-active !important;
    }

    span.score {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      max-width: 100px;
      left: 50%;
      margin-right: 40%;
      @media all and (max-width: $breakpoint-medium) {
        display: none;
      }
    }

    .score {
      text-align: center;
      font-weight: bold;
      position: relative;

      .average-score {
        color: rgb(124, 124, 124);
        font-weight: normal;
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }

    .feedback {
      margin-bottom: 25px;

      ul,
      ol {
        margin-bottom: 1.2em;
        li {
          background: none!important;
          border: none;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
